import auth from 'b2b-common/services/auth'

import privateView from './index'

import accountView from './account'
import infoView from './info'
import { packageViews } from './package/router'
import hotelViews from './hotel/router'
import bookingViews from './bookings/router'
import tourViews from './tour/router'

// TODO: add routes for packages, tours and hotels (for Tudor to do)

export default {
  path: 'private',
  name: 'Private/Default',
  component: privateView,
  redirect: { name: 'Private/Package' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) next()
      else next({ name: 'Public/Default' })
    }, () => {
      next({ name: 'Public/Default' })
    })
  },
  children: [
    packageViews,
    tourViews,
    hotelViews,
    bookingViews,
    {
      path: 'cont',
      name: 'Private/Account',
      component: accountView
    },
    {
      path: 'info',
      name: 'Private/Info',
      component: infoView
    },
    {
      path: 'logout',
      name: 'Private/Logout',
      beforeEnter: (to, from, next) => {
        auth.logout()
          .then(() => {
            // TODO: inform of succcesful logout
            next({ name: 'Public/Default' })
          })
          .catch(() => {
            // TODO: inform user about problem
            next({ name: 'Private/Default' })
          })
      }
    }
  ]
}
